import React from "react";
import { IconPlus, PrimaryBlueButton } from "@velaro/velaro-component-lib";
import { useNavigate } from "react-router-dom";

export default function CreateChatWindowButton() {
  const navigate = useNavigate();

  return (
    <PrimaryBlueButton
      prefixIcon={<IconPlus />}
      label="Create"
      onClick={() => navigate("/chat_window?create=true")}
    />
  );
}
